import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import * as React from "react";
import ARadioButton from "./hark/radioButton";
import { getPrefixCls } from "../config";
import { jsx as _jsx } from "react/jsx-runtime";
var RadioButton = function RadioButton(props, ref) {
  var prefixCls = getPrefixCls("radio");
  return /*#__PURE__*/_jsx(ARadioButton, _objectSpread(_objectSpread({
    prefixCls: prefixCls
  }, props), {}, {
    ref: ref
  }));
};
export default /*#__PURE__*/React.forwardRef(RadioButton);